// extracted by mini-css-extract-plugin
export default {"textareaWrapper":"textarea_textareaWrapper__48EyV"};